import styled from "styled-components";
import { theme } from "theme";

export const PurchaseSubscriptionContainer = styled.div`
  padding: ${theme.spacing(3)};
`;

export const StepperContainer = styled.div`
  margin-bottom: ${theme.spacing(4)};
`;

export const PlanSelectionContainer = styled.div`
  margin-bottom: ${theme.spacing(3)};
`;

export const PlanCard = styled.div<{ isSelected: boolean }>`
  cursor: pointer;
  border: ${(props) => (props.isSelected ? 2 : 1)}px solid;
  border-color: ${(props) =>
    props.isSelected ? theme.palette.primary.main : theme.palette.grey[300]};
  border-radius: ${theme.shape.borderRadius}px;
  transition: border-color 0.2s ease-in-out;

  &:hover {
    border-color: ${theme.palette.primary.main};
  }
`;

export const PlanCardContent = styled.div`
  padding: ${theme.spacing(2)};
`;

export const PlanHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${theme.spacing(2)};
`;

export const PlanIcon = styled.div`
  margin-right: ${theme.spacing(1)};
`;

export const PlanTitle = styled.div`
  margin-left: ${theme.spacing(1)};
`;

export const PlanDescription = styled.div`
  margin-bottom: ${theme.spacing(2)};
  color: ${theme.palette.text.secondary};
`;

export const PlanFeatures = styled.div`
  margin-bottom: ${theme.spacing(2)};
`;

export const PlanPrice = styled.div`
  margin-top: ${theme.spacing(2)};
  color: ${theme.palette.primary.main};
  .MuiTypography-root {
    font-size: 16px;
  }
`;

export const PlanConfigurationContainer = styled.div`
  margin-top: ${theme.spacing(3)};
`;

export const PlanConfigurationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${theme.spacing(2)};
`;

export const FinalPriceContainer = styled.div`
  margin-top: ${theme.spacing(3)};
  padding: ${theme.spacing(2)} ${theme.spacing(4)};
  background-color: ${theme.palette.grey[50]};
  border-radius: ${theme.shape.borderRadius}px;
  border: 1px solid ${theme.palette.grey[200]};
`;

export const FinalPriceTitle = styled.div`
  color: ${theme.palette.primary.main};
  margin-bottom: ${theme.spacing(1)};
  font-weight: 600;
`;

export const FinalPriceCalculation = styled.div`
  font-family: monospace;
`;

export const PaymentInfoContainer = styled.div`
  margin-bottom: ${theme.spacing(3)};
`;

export const PaymentCard = styled.div`
  padding: ${theme.spacing(3)};
  margin-bottom: ${theme.spacing(3)};
  background-color: ${theme.palette.background.paper};
  border-radius: ${theme.shape.borderRadius}px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`;

export const PaymentInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: ${theme.spacing(2)};
`;

export const PaymentInfoItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${theme.spacing(2)};
`;

export const PaymentInfoIcon = styled.div`
  margin-right: ${theme.spacing(1)};
  color: ${theme.palette.primary.main};
`;

export const PaymentInfoContent = styled.div`
  flex: 1;
`;

export const PaymentInfoLabel = styled.div`
  color: ${theme.palette.text.secondary};
  font-size: 0.875rem;
`;

export const PaymentInfoValue = styled.div`
  font-weight: 600;
  direction: rtl;
`;

export const UploadContainer = styled.div`
  margin-bottom: ${theme.spacing(3)};
`;

export const UploadArea = styled.div`
  border: 2px dashed ${theme.palette.grey[300]};
  border-radius: ${theme.spacing(2)};
  padding: ${theme.spacing(4)};
  text-align: center;
  margin-bottom: ${theme.spacing(3)};
  transition: border-color 0.2s ease-in-out;

  &:hover {
    border-color: ${theme.palette.primary.main};
  }
`;

export const UploadIcon = styled.div`
  font-size: 48px;
  color: ${theme.palette.grey[400]};
  margin-bottom: ${theme.spacing(2)};
`;

export const UploadText = styled.div`
  margin-bottom: ${theme.spacing(2)};
`;

export const UploadInput = styled.input`
  margin: ${theme.spacing(2)} 0;
`;

export const UploadFileName = styled.div`
  color: ${theme.palette.primary.main};
  font-size: 0.875rem;
`;

export const NavigationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${theme.spacing(3)};
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${theme.spacing(4)};
`;

export const ErrorContainer = styled.div`
  margin: ${theme.spacing(2)};
`;
